// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"27a51793","16":"7e3acd34","70":"48b3d5f8","164":"9d4dbd8c","208":"d8f7a08c","367":"437e722a","437":"fa6fb78f","536":"fa6fb78f","694":"fa6fb78f","722":"1635613b","825":"48b3d5f8","903":"65717225","952":"54beca24"}[chunkId] + ".chunk.css";
};